import { isRejectedWithValue } from "@reduxjs/toolkit";
import { saveAlertMessage } from "./alertMessage";

export const rtkQueryErrorLogger = ({ dispatch }) => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    console.log("RTK Error: ", action);

    const status = action?.payload?.status;
    const message = action?.payload?.data?.message;

    if (status === 400) {
      dispatch(saveAlertMessage(message || "Bad Request"));
    } 
    else if (status === 401) {
      dispatch(saveAlertMessage("You are already logged in on a different device"));

      setTimeout(() => {
        localStorage.clear();
        window.location.reload();
      }, 1500);
    } 
    else if (status === 500) {
      dispatch(saveAlertMessage("HTTP ERROR 500"));
    } 
    else if (message) {
      dispatch(saveAlertMessage(message));
    } 
    else {
      dispatch(saveAlertMessage("NETWORK ERROR"));
    }
  }

  return next(action);
};
